/**
 * @generated SignedSource<<f3644a6d695d10953b5be720a101cfeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Header_provider$data = {
  readonly name: string;
  readonly cover: {
    readonly transformedSrc: string;
  } | null;
  readonly city: {
    readonly name: string;
    readonly province: {
      readonly shortName: string;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
  readonly " $fragmentType": "Header_provider";
};
export type Header_provider$key = {
  readonly " $data"?: Header_provider$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_provider">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_provider",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": 128
        }
      ],
      "kind": "FragmentSpread",
      "name": "Avatar_actor"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "maxHeight",
              "value": 256
            },
            {
              "kind": "Literal",
              "name": "maxWidth",
              "value": 1290
            }
          ],
          "kind": "ScalarField",
          "name": "transformedSrc",
          "storageKey": "transformedSrc(maxHeight:256,maxWidth:1290)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "City",
      "kind": "LinkedField",
      "name": "city",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Province",
          "kind": "LinkedField",
          "name": "province",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shortName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Provider",
  "abstractKey": null
};
})();

(node as any).hash = "50af01af605f345f77cb64b7a7849266";

export default node;
